<template>
    <v-btn
      tile
      color="grey lighten-1"
      elevation="0"
      class="ml-2"
      @click="click">
        {{ label }}
      <v-icon v-if="icon" right dark>
        {{ icon }}
      </v-icon>
    </v-btn>
</template>

<script>
export default {
  name: 'BaseInputSecondaryButton',
  props: {
    label: {
      type: String,
      require: true
    },
    icon: {
      type: String,
      require: false
    }
  },
  methods: {
    click () {
      this.$emit('click')
    }
  }
}
</script>

<style scoped>

</style>
